import * as React from 'react';
import { ClickTracker } from 'bernie-analytics';
import { ErrorBoundary } from 'bernie-view';
import { EGDSSecondaryButton } from '@egds/react-core/button';
import { EGDSLayoutFlex } from '@egds/react-core/layout-flex';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { LocalizedText } from '@shared-ui/localization-context';
const ButtonTracked = ClickTracker(EGDSSecondaryButton);
export const ShowMoreButton = ({
  onNextSubset,
  isLoading,
  rfrr,
  linkName
}) => React.createElement(ErrorBoundary, {
  label: "hotel.search.showMoreResultsButton"
}, React.createElement(EGDSSpacing, {
  padding: {
    blockstart: 'three'
  }
}, React.createElement(EGDSLayoutFlex, {
  justifyContent: "center",
  tag: "section"
}, React.createElement(ButtonTracked, {
  disabled: isLoading,
  "data-stid": "show-more-results",
  onClick: onNextSubset,
  rfrr: rfrr,
  linkName: linkName
}, React.createElement(LocalizedText, {
  message: "hotels.searchResults.paginationButton.label"
})))));